'use client';
import React from 'react';
import { toast } from 'sonner';

export const HowToConnect = () => {
  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard!');
  };
  return (
    <div className="pt-[82px] lg:pt-[182px] px-4">
      <div className="max-w-[1190px] flex flex-col gap-[101px] mx-auto w-full">
        <div className="max-w-[771px] relative w-full mx-auto  text-center">
          <img
            src="/assets/alien14.png"
            className=" max-w-[57px] lg:max-w-[129px] w-full absolute left-[25px] lg:left-9 top-[110px] lg:top-[-34px]"
            alt=""
          />
          <h2 className="font-normal text-[40px] lg:text-[62px] font-koulen leading-[136%] tracking-[-4%] uppercase">
            How to Connect to
          </h2>
          <h3 className="uppercase font-normal text-[60px] lg:text-[100px] leading-[100%] text-[#D6FF00] font-koulen">
            Layer Brett Testnet
          </h3>
        </div>
        <div className="flex justify-between items-end flex-col lg:flex-row gap-[74px] lg:gap-0">
          <div className="max-w-[387px] w-full rounded-[23px] border-4 border-[#009BAF] relative">
            <span className="max-w-[146px]  px-[19px] flex items-center gap-[14px] absolute left-[50%] max-lg:-translate-x-1/2 lg:left-[45px] top-[-26px] w-full  shadow-outerDesk h-[50px] rounded-[5px] bg-[#FFB3E8] border-4 border-[#EF53C0C0]">
              <span className="text-[#003E57] text-[20px] font-koulen">Step</span>
              <img src="/assets/01.png" alt="" />
            </span>
            <div className="max-w-[296px] max-lg:text-center w-full mx-auto pt-[69px] pb-[60px] flex flex-col gap-[34px]">
              <span className="text-2xl text-[#D6FF00] font-normal font-koulen leading-[100%]">
                add Testnet to MetaMask
              </span>
              <p className="text-lg font-normal font-koulen leading-[130%]">
                Click below to automatically add the network to your wallet:
              </p>
              <button className="mt-[14px] max-lg:mx-auto max-w-[258px] w-full h-[54.85039520263672px] bg-[#FFBCB3] border-[#F36C6A] shadow-orangeShadow text-[#003E57] font-koulen text-center flex justify-center items-center text-[22.02px] border-[2.33px] rounded-[5.84px]">
                Add to MetaMask
              </button>
            </div>
          </div>
          <div className="max-w-[760px] w-full relative rounded-[15px] bg-[#0487AB] border-[#003E58] border-4 shadow-outerDesk px-[18px] pt-[54px] lg:pt-10 pb-[30px] ">
            <img
              src="/assets/alien81.png"
              className="absolute right-0 lg:right-[22px] max-lg:max-w-[71px] -top-10 lg:top-[-79px] z-0 transform scale-x-[-1]"
              alt=""
            />
            <span className="max-w-[146px]  px-[19px] flex items-center gap-[14px] absolute left-[50%] max-lg:-translate-x-1/2 lg:left-[45px] top-[-26px] w-full  shadow-outerDesk h-[50px] rounded-[5px] bg-[#FFB3E8] border-4 border-[#EF53C0C0]">
              <span className="text-[#003E57] text-[20px] font-koulen">Step</span>
              <img src="/assets/01.png" alt="" />
            </span>
            <div className="flex flex-col gap-[9px]">
              {/* <h2 className="stroked3 koulen  text-[30px] font-normal ">Manual Network Setup</h2> */}
              <img
                src="/assets/Manual Network Setup.png"
                className=" max-w-[263px] max-lg:mx-auto lg:max-w-[263px]"
                alt=""
              />
              <div className="flex gap-2 items-center">
                <span className="w-3 h-3 hidden lg:block rounded-full bg-[#D6FF00]"></span>
                <p className="uppercase text-lg max-lg:text-center font-normal text-[#003E58] font-koulen leading-[130%] pb-[7px]">
                  If your wallet doesn't support auto-add, use these settings:
                </p>
              </div>
            </div>
            <div className="w-full bg-[#005870] border-4 border-[#003E58] shadow-custom-inset pt-[37px] pb-[33px] px-6 lg:px-[33px]">
              <div className="max-w-[724px] w-full flex flex-col gap-[30px] lg:gap-[3px]">
                <div className="flex flex-col lg:flex-row items-center gap-3 lg:gap-[37px]">
                  <span className="text-base font-[900] font-obriton text-white">Network Name</span>
                  <div className="bg-[#0487AB] max-lg:text-center border-[#003E58] border-[2.94px] max-lg:w-full pl-[18.38px] pr-[36px] py-[6px] shadow-cardShadow rounded-[11.03px] text-[20.53px] leading-[100%] text-[#D6FF00] font-koulen font-normal ">
                    Layer Brett Testnet
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row items-center gap-3 lg:gap-[81px]">
                  <span className="text-base font-[900] font-obriton text-white">RPC URL: </span>

                  <div className="bg-[#0487AB] border-[#003E58] border-[2.94px] max-lg:w-full pl-[18.38px] pr-[36px] py-[6px] shadow-cardShadow rounded-[11.03px] text-[20.53px] leading-[100%] text-[#D6FF00] font-koulen font-normal flex items-center gap-2">
                    <span className="max-lg:text-center break-all">https://testnet-tx-rpc.layerbrettchain.com</span>

                    <img
                      src="/assets/solar_copy-bold.png"
                      className="cursor-pointer w-[22px] h-[22px]"
                      onClick={() => handleCopy('https://testnet-tx-rpc.layerbrettchain.com')}
                      alt="copy"
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row items-center gap-3 lg:gap-[92px]">
                  <span className="text-base font-[900] font-obriton text-white">Chain ID: </span>
                  <div className="bg-[#0487AB] max-lg:text-center border-[#003E58] border-[2.94px] max-lg:w-full pl-[18.38px] pr-[20px] py-[6px] shadow-cardShadow rounded-[11.03px] text-[20.53px] leading-[100%] text-[#D6FF00] font-koulen font-normal ">
                    4500
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row items-center gap-3 lg:gap-[53px]">
                  <span className="text-base max-lg:text-center lg:max-w-[116px] w-full font-[900] font-obriton text-white">
                    Currency Symbol:{' '}
                  </span>
                  <div className="bg-[#0487AB] max-lg:text-center border-[#003E58] border-[2.94px] max-lg:w-full pl-[18.38px] pr-[16.8px] py-[6px] shadow-cardShadow rounded-[11.03px] text-[20.53px] leading-[100%] text-[#D6FF00] font-koulen font-normal ">
                    ETH
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row items-center gap-3 lg:gap-[28px]">
                  <span className="text-base font-[900] font-obriton text-white">Block Explorer:</span>

                  <div className="bg-[#0487AB] border-[#003E58] border-[2.94px] max-lg:w-full pl-[18.38px] pr-[22px] py-[6px] shadow-cardShadow rounded-[11.03px] text-[20.53px] leading-[100%] text-[#D6FF00] font-koulen font-normal flex items-center gap-2">
                    <span className="break-all max-lg:text-center">https://testnet-explorer.layerbrettchain.com/</span>

                    <img
                      src="/assets/solar_copy-bold.png"
                      className="cursor-pointer w-[20px] h-[20px]"
                      onClick={() => handleCopy('https://testnet-explorer.layerbrettchain.com/')}
                      alt="copy"
                    />
                  </div>
                </div>
                <div className="pt-[15px]  lg:hidden flex items-center gap-2">
                  <p className="text-base text-center text-[#D6FF00] leading-[130%] font-koulen font-normal ">
                    A fast, low-cost Optimism Layer 2{' '}
                    <span className="text-[#132D4E]">
                      {' '}
                      — infused with Brett culture and powered by Ethereum Sepolia for testing.
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="pt-[15px] hidden lg:flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-[#D6FF00]"></span>
              <p className="text-base text-[#D6FF00] leading-[130%] font-koulen font-normal ">
                A fast, low-cost Optimism Layer 2{' '}
                <span className="text-[#132D4E]">
                  {' '}
                  — infused with Brett culture and powered by Ethereum Sepolia for testing.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
